import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as FormReducer from '../../actions/FormHandler.js';

export class Circle extends Component{
    _showForm = () => {
        this.props.modal.show(this.props.date, this.props.time);
    }

    render(){
        return (
            <div className="circle" onClick={this._showForm}>
                <span className="circle-center">+</span>
            </div>
        );
    }
}

const mapStateToProps = state => ({});

function mapDispatchToProps(dispatch) {
    return {
        modal: bindActionCreators(FormReducer, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Circle);


// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/Circle.jsx